import { colors } from './colors';

// Responsive helper functions that work with dynamic values
export const getResponsiveStyles = (screenWidth) => ({
  container: {
    flex: 1,
    backgroundColor: colors.background,
    minHeight: '100vh',
    width: '100%',
  },
  
  // Responsive containers
  pageContainer: {
    maxWidth: screenWidth >= 1440 ? 1400 : screenWidth >= 1200 ? 1200 : screenWidth >= 1024 ? 1024 : '100%',
    margin: '0 auto',
    padding: screenWidth >= 1024 ? '0 40px' : screenWidth >= 768 ? '0 24px' : '0 16px',
    width: '100%',
    minHeight: '100vh',
    boxSizing: 'border-box',
  },

  // Responsive padding
  responsivePadding: {
    padding: screenWidth >= 1024 ? '32px' : screenWidth >= 768 ? '24px' : '16px',
  },

  // Responsive margins
  responsiveMargin: {
    margin: screenWidth >= 1024 ? '24px 0' : screenWidth >= 768 ? '20px 0' : '16px 0',
  },

  // Responsive cards
  card: {
    backgroundColor: colors.cardBackground,
    borderRadius: screenWidth >= 1024 ? 16 : screenWidth >= 768 ? 12 : 8,
    padding: screenWidth >= 1024 ? 24 : screenWidth >= 768 ? 20 : 16,
    boxShadow: `0 ${screenWidth >= 1024 ? 4 : 2}px ${screenWidth >= 1024 ? 8 : 4}px ${colors.shadow}`,
    border: '1px solid rgba(0, 0, 0, 0.05)',
    width: '100%',
    boxSizing: 'border-box',
  },

  // Responsive grids
  responsiveGrid: {
    display: 'flex',
    flexDirection: screenWidth >= 1024 ? 'row' : 'column',
    flexWrap: 'wrap',
    gap: screenWidth >= 1024 ? 24 : screenWidth >= 768 ? 20 : 16,
    justifyContent: screenWidth >= 1024 ? 'space-between' : 'stretch',
  },

  responsiveGridTwoCol: {
    display: 'flex',
    flexDirection: screenWidth >= 768 ? 'row' : 'column',
    gap: screenWidth >= 768 ? 20 : 16,
    justifyContent: 'space-between',
  },

  responsiveGridThreeCol: {
    display: 'grid',
    gridTemplateColumns: screenWidth >= 1200 ? 'repeat(3, 1fr)' : screenWidth >= 768 ? 'repeat(2, 1fr)' : '1fr',
    gap: screenWidth >= 1024 ? 24 : screenWidth >= 768 ? 20 : 16,
  },

  // Responsive text input
  textInput: {
    border: `1px solid ${colors.border}`,
    borderRadius: screenWidth >= 1024 ? 12 : screenWidth >= 768 ? 10 : 8,
    padding: screenWidth >= 1024 ? '16px' : screenWidth >= 768 ? '14px' : '12px',
    fontSize: screenWidth >= 1024 ? '16px' : screenWidth >= 768 ? '15px' : '14px',
    color: colors.text,
    backgroundColor: colors.white,
    minHeight: screenWidth >= 1024 ? 52 : screenWidth >= 768 ? 48 : 44,
    width: '100%',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s ease',
    '&:focus': {
      borderColor: colors.primary,
    },
  },

  // Responsive buttons
  button: {
    backgroundColor: colors.primary,
    color: colors.white,
    border: 'none',
    borderRadius: screenWidth >= 1024 ? 12 : screenWidth >= 768 ? 10 : 8,
    padding: screenWidth >= 1024 ? '16px 24px' : screenWidth >= 768 ? '14px 20px' : '12px 16px',
    fontSize: screenWidth >= 1024 ? '16px' : screenWidth >= 768 ? '15px' : '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    minHeight: screenWidth >= 1024 ? 52 : screenWidth >= 768 ? 48 : 44,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: colors.primaryDark,
    },
  },

  // Utility classes
  centered: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },
  
  shadow: {
    boxShadow: `0 ${screenWidth >= 1024 ? 4 : 2}px ${screenWidth >= 1024 ? 8 : 4}px ${colors.shadow}`,
  },
});

// Static styles that don't need responsiveness
export const globalStyles = {
  // Fallback for static usage
  ...getResponsiveStyles(1024),
  
  // Non-responsive utilities
  hidden: {
    display: 'none',
  },
  
  visible: {
    display: 'block',
  },
  
  flex: {
    display: 'flex',
  },
  
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  
  justifyCenter: {
    justifyContent: 'center',
  },
  
  alignCenter: {
    alignItems: 'center',
  },
  
  textCenter: {
    textAlign: 'center',
  },
  
  fullWidth: {
    width: '100%',
  },
  
  fullHeight: {
    height: '100%',
  },
};